import React, { useEffect, useMemo, useRef, useState } from "react";
import debounce from 'lodash.debounce';
import { Link, useNavigate } from "react-router-dom";
import Datatable from '../../ExtraComponents/ReusableTable2';
import { getAllQuotes, lastFiveQuote, deleteQuote, convertQuote, createQuote } from "../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { useDispatch } from "react-redux";
import { PenLine, Trash2, Weight } from 'lucide-react';
import { DateConvert, DateConvertWithTime, cleanHtmlEntities, roundNumber } from '../../Utils/CommonFun';
import Swal from "sweetalert2";
import { getDashboardData } from '../../ReduxStore/Slice/Dashboard/dashboardSlice'
import ReactPaginate from "react-paginate";


import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs"
import { DatePicker, Space, theme } from 'antd';
import axios from "axios";
import * as Config from "../../Utils/Config";


const QuotesDashboard = () => {

  const dispatch = useDispatch();
  const nevigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const userDetails = JSON.parse(localStorage.getItem("details"));
  const [lastFiveQuoteData, setLastFiveQuoteData] = useState([]);
  const [activeTab, setActiveTab] = useState("current-month");
  const [dashboard, setDashboard] = useState([])
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  const [pageSize, setPageSize] = useState(50);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [range, setRange] = useState(null);



  const quote_created_amount = roundNumber(dashboard?.quote_created_list?.row_total)

  const quote_sent_amount = roundNumber(dashboard?.quote_sent_list?.row_total)

  const quote_unsent_amount = roundNumber(dashboard?.quote_unsent_list?.row_total)

  const quote_reviewed_amount = roundNumber(dashboard?.quote_reviewed_list?.row_total)

  const quote_accepted_amount = roundNumber(dashboard?.quote_accepted_list?.row_total)

  const quote_rejected_amount = roundNumber(dashboard?.quote_rejected_list?.row_total)



  // console.log("agent_id", agent_id);
  // Quote Dashboard Data
  const DashboardData = async () => {
    setLoading(true);
    let req = { agent_id: agent_id, filter: activeTab, link: "quote" };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    await dispatch(getDashboardData(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setDashboard(response.data)
          // setLoading(false);
        }
        else {
          setDashboard([])
          //  setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      })
  }

  useEffect(() => {
    DashboardData()
  }, [activeTab, range]);

  const handleTabChange = (event) => {
    setActiveTab(event.target.value);
  };

  const isSearchTriggered = useRef(false);

  // 1000ms debounce - actual search (InputValue) tabhi update hoga jab user typing rok de
  const debouncedSetInputValue = useMemo(
    () => debounce((value) => {
      isSearchTriggered.current = true;
      setInputValue(value);
    }, 1000),
    []
  );

  useEffect(() => {
    return () => debouncedSetInputValue.cancel();
  }, [debouncedSetInputValue]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);          // input turant update (UI responsive)
    debouncedSetInputValue(value); // API call 1000ms baad
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])

  useEffect(() => {
    getLastFiveQuote();
  }, [currentPage, pageSize, InputValue, activeTab, range]);



  const getLastFiveQuote = async () => {
    const isSearch = isSearchTriggered.current;
    isSearchTriggered.current = false;
    if (!isSearch) {
      setLoading(true);
    }
    let req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue, filter: activeTab };
    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }
    await dispatch(lastFiveQuote(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setLastFiveQuoteData(response.data);
          setTotalRecords(response?.pagination?.total || 0);
          if (!isSearch) setLoading(false);

        } else {
          setLastFiveQuoteData([]);
          if (!isSearch) setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
        if (!isSearch) setLoading(false);
      });
  };

  const handleStopReminder = async (row) => {

    let stop_remainder_status = row.stop_remainder_status;
    let msg = "Stop";
    if (Number(row.stop_remainder_status) == 1) {
      stop_remainder_status = '0';
      msg = "Start";
    } else {
      stop_remainder_status = '1';
      msg = "Stop";
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${msg} reminder for this contract!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: true,
      confirmButtonText: "Ok",
      confirmButtonText: msg + " Reminder",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, stop_remainder_status: stop_remainder_status, step: 5 };

        // console.log("req", req);
        await dispatch(createQuote(req))
          .unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: "Success!",
                text: `Reminder ${msg} successfully.`,
                icon: "success",
                showConfirmButton: true,
                confirmButtonText: "Ok",

                timer: 3000,
              });
              getLastFiveQuote();
            } else {
              Swal.fire("Error!", "Something went wrong.", "error");
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });

  }

  const columns = [
    {
      name: "Sales Person",
      selector: (row) =>
        `${row?.User?.user_fname ?? ""} ${row?.User?.user_lname ?? ""}`.trim(),
      sortable: true,
      sortFunction: (a, b) => {
        const nameA = `${a?.User?.user_fname ?? ""} ${a?.User?.user_lname ?? ""}`
          .trim()
          .toLowerCase();
        const nameB = `${b?.User?.user_fname ?? ""} ${b?.User?.user_lname ?? ""}`
          .trim()
          .toLowerCase();
        return nameA.localeCompare(nameB);
      },
    },
    {
      name: "Client",
      selector: (row) => cleanHtmlEntities(row?.Client?.client_name),
      sortable: true,
      sortFunction: (a, b) => {
        const nameA = cleanHtmlEntities(a?.Client?.client_name ?? "")
          .trim()
          .toLowerCase();
        const nameB = cleanHtmlEntities(b?.Client?.client_name ?? "")
          .trim()
          .toLowerCase();
        return nameA.localeCompare(nameB);
      },
    },

    {
      name: "Created On",
      selector: row => row.createdAt,
      cell: row => DateConvertWithTime(row.createdAt),
      sortable: true,
      sortFunction: (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    // 0 = Inprogress, 1 = Accepted, 2 = Rejected, 3 = Pending
    // {
    //   name: "Status",
    //   selector: (row) => ({
    //     0: "In Progress",
    //     1: "Quote Accepted",
    //     2: "Quote Rejected",
    //     3: "Quote Sent",
    //   }[Number(row?.status)] || "-"),
    //   sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => {
        const status = Number(row?.status);

        if (status === 0) {
          // Yaha apni extra condition lagao
          if (Number(row?.higher_discount_status) === 0 && Number(row?.request_higher_discount_ongoing) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status_oneoff) === 0 && Number(row?.request_higher_discount_oneoff) === 1) {
            return "Requested Higher Discount";
          }
          else if (Number(row?.higher_discount_status) === 1 || Number(row?.higher_discount_status_oneoff) === 1) {
            return "Discount Approved";
          }
          else if (Number(row?.higher_discount_status) === 2 || Number(row?.higher_discount_status_oneoff) === 2) {
            return "Discount Rejected";
          }
          else {
            return "In Progress";
          }
        }

        return {
          1: "Quote Accepted",
          2: "Quote Rejected",
          3: "Quote Sent",
        }[status] || "-";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (

        <div className="d-flex w-100 justify-content-start align-items-center">
          {Number(row?.status) != 0 && row?.Contracts?.length === 0
            ?
            <button className="btn btn-sm-pink" onClick={(e) => handleConvert(e, row)}>
              <i className=" ri-repeat-line pe-1" />
              Convert
            </button>
            : ""
          }

           {Number(row?.status) === 0 ?
           <>
          <button className="btn fs-4 py-0 px-1" onClick={() => handleEdit(row)}>
            <i className=" ri-edit-line" />
          </button>

          <button className="btn fs-4 py-0 px-1" onClick={() => handleDelete(row)}>
            <i className="bx bx-trash" />
          </button>
          </>
          :""}

          {/* Resend Contract Button with appropriate icon */}
          {/* {
          Number(row?.status) !== 0 ?
            <>
              <button
                className="btn fs-4 py-0 px-1"
                onClick={() => handleStopReminder(row)}
                title={Number(row.stop_remainder_status) === 1 ? "Start Reminder" : "Stop Reminder"}
              >
                <i
                  className={`ri-timer-line ${Number(row.stop_remainder_status) === 1 ? "text-danger" : "text-success"
                    }`}
                />
              </button>
            </> :
            ""
          } */}
        </div>
      ),
      sortable: true,
      width: "220px",
    }
  ];

  const handleConvert = async (e, row) => {

    let req = { row: row };
    await dispatch(convertQuote(req)).unwrap()
      .then((res) => {
        if (res.status) {

          sessionStorage.setItem("contract_id", res.contract_id);
          nevigate("/admin/contracts/create-contract", { state: { row: { id: res.contract_id, step: 3 } } });
        }
        else {
          console.log("err", res);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });


  };

  const handleEdit = (row) => {
    // const encodedId = btoa(row.id.toString());
    // nevigate(`/admin/quote/create-quote/${encodedId}`);
    nevigate("/admin/quote/create-quote", { state: { row: row } });
  };

  const handleDelete = async (row) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this quote!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, user_id: userDetails?.id };
        await dispatch(deleteQuote(req)).unwrap()
          .then((response) => {
            if (response.status) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your quote has been deleted.',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                getLastFiveQuote();
              });
            } else {
              Swal.fire('Error!', 'Something went wrong.', 'error');
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your quote is safe :)', 'error')
      }
    });


  };

  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);

  const goToQuotes = (val) => {
    nevigate("/admin/quote/all-quotes", {
      state: {
        // range : range,
        range: range
          ? [
            range[0].toISOString(),
            range[1].toISOString()
          ]
          : null,
        activeTab: activeTab || "",
        quoteTiles: val || ""
      }
    });
  };

  const handleExport = async () => {

    let totalData = lastFiveQuoteData;

    let req = { agent_id: agent_id, page: 1, limit: 100000, search: "", filter: activeTab, quoteTiles: "" };

    if (activeTab === "custom-date" && Array.isArray(range) &&
      range[0] &&
      range[1]) {
      req = {
        ...req,
        startDate: dayjs(range[0])?.format("YYYY-MM-DD"),
        endDate: dayjs(range[1])?.format("YYYY-MM-DD")
      };
    }

    await dispatch(lastFiveQuote(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'No Data',
            text: 'No data to export!',
          });
          return
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: 'warning',
          title: 'No Data',
          text: 'No data to export!',
        });
        return
      });

    if (totalData.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      return
    }

    // export format
    const exportData = totalData?.map((row) => ({
      "Sales Person": `${row?.User?.user_fname ?? ""} ${row?.User?.user_lname ?? ""}`.trim(),
      "Client": row?.Client?.client_name,
      "Created On": DateConvertWithTime(row?.createdAt),
      "Status": Number(row?.status) === 3 ? "Quote Sent" :
        Number(row?.status) === 5 ? "Quote Reviewed" :
          Number(row?.status) === 1 ? "Quote Accepted" :
            Number(row?.status) === 2 ? "Quote Rejected" :
              "In Progress",
    }));

    downloadCSV(exportData, "Quote Details.csv");
  };
  const downloadCSV = (data, filename) => {
    const csvRows = [];

    // headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // rows
    data.forEach((row) => {
      const values = headers.map((h) => `"${row[h] || ""}"`);
      csvRows.push(values.join(","));
    });

    const csvString = csvRows.join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
  };

  const handleExportPDF = async () => {
    setLoading(true);
    let totalData = lastFiveQuoteData;

    let req = { agent_id: agent_id, page: 1, limit: 100000, search: "", filter: activeTab, quoteTiles: "" };

    if (
      activeTab === "custom-date" &&
      Array.isArray(range) &&
      range[0] &&
      range[1]
    ) {
      req.startDate = dayjs(range[0]).format("YYYY-MM-DD");
      req.endDate = dayjs(range[1]).format("YYYY-MM-DD");
    }

    await dispatch(lastFiveQuote(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          totalData = response.data
        } else {
          setLoading(false);
          Swal.fire({
            icon: 'warning',
            title: 'No Data',
            text: 'No data to export!',
          });
          return
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: 'warning',
          title: 'No Data',
          text: 'No data to export!',
        });
        return
      });

    if (totalData.length === 0) {
      setLoading(false);
      Swal.fire({
        icon: 'warning',
        title: 'No Data',
        text: 'No data to export!',
      });
      return
    }



    // export format
    const formattedData = totalData?.map((row) => ({
      salesPerson: `${row?.User?.user_fname ?? ""} ${row?.User?.user_lname ?? ""}`.trim(),
      subject: row?.subject,
      client: row?.Client?.client_name,
      createdAt: DateConvertWithTime(row?.createdAt),
      status: Number(row?.status) === 3 ? "Quote Sent" :
        Number(row?.status) === 5 ? "Quote Reviewed" :
          Number(row?.status) === 1 ? "Quote Accepted" :
            Number(row?.status) === 2 ? "Quote Rejected" :
              "In Progress",
    }));

    const pdfColumns = [
      { label: "Sales Person", key: "salesPerson" },
      // { label: "Subject", key: "subject" },
      { label: "Client", key: "client" },
      { label: "Created On", key: "createdAt" },
      { label: "Status", key: "status" },
    ];

    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData, columns: pdfColumns },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "Quote_Details.pdf";
    a.click();
  };

  const showPagination = pageSize !== 0 && Math.ceil(totalRecords / pageSize)

  return (
    <div>
      <>
        <div className="row mb-3">
          <div className="col">
            <h4 className="page-title">Quotes</h4>
          </div>
          <div className="col-auto align-self-center">
            {lastFiveQuoteData?.length > 0 && (
              <>
                <button className="btn-outline-pink btn me-2"
                  onClick={handleExportPDF}
                >
                  <i className="ri-download-2-line"></i> Export PDF
                </button>

                <button className="btn-outline-pink btn me-2"
                  onClick={handleExport}
                >
                  <i className="ri-download-2-line"></i>  Export CSV
                </button>
              </>
            )}
            <Link
              to="/admin/quote/create-quote"
              className="btn btn-pink"
              id="Dash_Date"
            >
              <span className="ay-name" id="Day_Name">
                Add New Quote
              </span>
            </Link>
          </div>
        </div>
        <div className="row"> <div className=" col-lg-3 filter-select mb-3">
          <data className=" datatable-search">
            <input
              type="text"
              className="search p-2 icon"
              placeholder="Search here"
              value={searchText}
              onChange={handleSearchChange}
            />
          </data>
        </div>
          <div className="col-lg-3 filter-select mb-3 select_tab" >
            <select
              onChange={handleTabChange}
              value={activeTab}
              className="form-select"
            >
              <option value="current-month">Current Month</option>
              <option value="prev-month">Previous Month</option>
              <option value="current-quarter">Current Quarter</option>
              <option value="previous-quarter">Previous Quarter</option>
              <option value="current-calender-quarter">
                Current Calendar Year
              </option>
              <option value="prev-calender-year">Previous Calendar Year</option>
              <option value="custom-date">Custom Date</option>
            </select></div>



          {activeTab === "custom-date" && (
            <div className="col-lg-3 d-flex gap-2 mb-3" style={{ marginTop: "-8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DateRangePicker"]}>
                  <DatePicker.RangePicker
                    value={range}
                    onChange={setRange}
                    placeholder={['Start Date', 'End Date']}
                    format="DD/MM/YYYY"
                    className=""
                  />
                  {/* <DateRangePicker
                    localeText={{ start: "From", end: "To" }}
                    value={dateRange}
                    onChange={(newValue) => {
                      const formattedStartDate = newValue[0] ? dayjs(newValue[0]).format("YYYY-MM-DD") : null;
                      const formattedEndDate = newValue[1] ? dayjs(newValue[1]).format("YYYY-MM-DD") : null;

                      setStartDate(formattedStartDate);
                      setEndDate(formattedEndDate);
                      setDateRange(newValue);
                    }}
                  /> */}
                </DemoContainer>
              </LocalizationProvider>
            </div>
          )}
        </div>



        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToQuotes("quote-created")}
                    style={{ cursor: "pointer" }}
                  >

                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Created</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.created || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_created_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToQuotes("quote-unsent")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Unsent</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.unsent || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_unsent_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToQuotes("quote-sent")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Sent</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.sent || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_sent_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>





                {/* <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={()=>goToQuotes("quote-reviewed")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Reviewed</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.reviewed || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_reviewed_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}


                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToQuotes("quote-accepted")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Accepted</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.accepted || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_accepted_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card cursor-pointer"
                    onClick={() => goToQuotes("quote-rejected")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title pb-4">Quotes Rejected</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboard?.rejected || 0}</h6>
                        </div>
                        <div className="fstiles">
                          £{quote_rejected_amount || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section dashboard">
          <div className="table-main-div">
            <div className="table-recent-head-div">
              <div className="row">
                <div className="col">
                  <span className="text-pink font-16">Recent</span>
                </div>
                <div className="col-auto align-self-center">
                  <Link to="/admin/quote/all-quotes">
                    <span className="text-pink font-16">See All</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="quote-table">
                <Datatable
                  columns={columns}
                  data={lastFiveQuoteData}
                  filter={false}
                />
                {
                  lastFiveQuoteData && lastFiveQuoteData.length > 0 ?
                    <>
                      {
                        showPagination > 1 && (
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                          />
                        )
                      }


                      <div className="mt-0">
                        <select
                          // className="perpage-select" 
                          className={showPagination > 1 ? "perpage-select" : "perpage-select mt-3 mb-3"}
                          value={pageSize}
                          onChange={handlePageSizeChange}>
                          {/* <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option> */}
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                          <option value={500}>500</option>
                          <option value={0}>{"ALL"}</option>
                        </select>
                      </div>
                    </>
                    :
                    null

                }

              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  );
};

export default QuotesDashboard;
